import Lenis from '@studio-freight/lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { throttle, debounce } from 'throttle-debounce'
import App from '@scripts/app'

export default class ScrollManager {
  /**
   * Starts smooth scroll.
   * By default, smooth scroll will be disabled under tablet breakpoint.
   *
   */
  constructor() {
    this.S = new Lenis({
      duration: 1.6, wrapper: App.domWrapper, content: App.domScroll
    })

    App.S = this.S

    this.bindMethods()
    this.initScrollTrigger()
  }

  bindMethods() {
    this.scroll = this.scroll.bind(this)
    this.scrollNative = this.scrollNative.bind(this)
    this.scrollEnded = this.scrollEnded.bind(this)

    this.scroll = throttle(200, this.scroll)
    this.scrollEnded = debounce(200, this.scrollEnded)
  }

  events() {
    this.S.on('scroll', this.scroll)
    this.S.on('scroll', this.scrollNative)
    this.S.on('scroll', this.scrollEnded)
  }

  /**
   * Setup ScrollTrigger default values.
   *
   * @returns {void}
   */
  initScrollTrigger() {
    ScrollTrigger.defaults({
      scrub: true, scroller: App.domWrapper
    })
  }

  /**
   * Scroll event. Throttled every 200ms.
   *
   * Automatically calls `.scroll()` method of needed components.
   *
   * @param {Event} e - The scroll event.
   *
   * @returns {void}
   */
  scroll(e) {
    if (App.isTransitioning) return

    App.header.scroll(e)
    App.currentRenderer.scroll(e)
    if (App.GLM) App.GLM.scroll(e)
  }

  /**
   * Scroll event. Native event (not throttled).
   *
   * Automatically calls `.scrollNative()` method of needed components.
   *
   * @param {Event} e - The scroll event.
   *
   * @returns {void}
   */
  scrollNative(e) {
    App.scrollY = e.scroll.y

    if (App.isTransitioning) return

    App.currentRenderer.scrollNative(e)
    ScrollTrigger.update()
  }

  toggle(bool) {
    bool ? this.S.start() : this.S.stop()
  }

  /**
   * Scroll end event. Debounced 200ms after last scroll event.
   *
   * Automatically calls `.scrollEnded()` method of needed components.
   *
   * @param {Event} e - The scroll event.
   *
   * @returns {void}
   */
  scrollEnded(e) {
    if (App.isTransitioning) return

    App.currentRenderer.scrollEnded(e)
  }

  render(time) {
    App.time = time

    this.S.raf(time * 1000)
  }
}
